import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { applyTheme, getTheme } from './lib/theme';

// Apply the saved light/dark choice before the first paint (login page included)
applyTheme(getTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
